<aside class="bg-white h-full flex flex-col gap-4 p-4 max-w-[300px] border-e">
  <a routerLink="/admin">
    <img src="/images/branding/andy-logo-black.svg" class="w-[60px] xl:w-[80px]" alt="ALEX CRM">
  </a>
  <div class="grow h-full max-h-full w-full max-w-full min-w-0 overflow-y-auto pe-2 overflow-x-hidden flex flex-col gap-1">
    @for (sidebarItem of sidebarItems; track sidebarItem.label) {
      <app-menu-sidebar-item class="block w-full max-w-full min-w-0" [menuSidebarItem]="sidebarItem"/>
    }
  </div>
</aside>
